const HistoricalReportsIconHome = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2692_10611)" />
      <path
        d="M46.0047 21.9977H43.0037V19.9988C43.0037 18.8929 42.1109 18 41.0049 18C39.899 18 39.0062 18.8929 39.0062 19.9988V21.9977H31.0053V19.9988C31.0053 18.8929 30.1125 18 29.0066 18C27.9006 18 27.0078 18.8929 27.0078 19.9988V21.9977H24.0068C22.3421 21.9977 21 23.3456 21 24.9988V28H49V24.9988C49 23.3399 47.6579 21.9977 45.999 21.9977H46.0047Z"
        fill="white"
      />
      <path
        d="M21 30V46.9997C21 48.6582 22.3418 50 24.0004 50H45.9996C47.6582 50 49 48.6582 49 46.9997V30H21ZM35.5356 33.4495C36.4167 33.5186 37.2805 33.772 38.0638 34.1808C38.847 34.5897 39.5381 35.1598 40.0967 35.8508C40.6553 36.5361 41.0699 37.3308 41.3118 38.1831L35.3628 39.3694C35.2879 39.2542 35.2188 39.1276 35.1613 39.0009L32.9268 33.7662C33.7676 33.484 34.6545 33.3746 35.5413 33.4495H35.5356ZM37.5512 46.0495C36.6701 46.4238 35.7141 46.6024 34.7524 46.5678C33.7906 46.5333 32.8519 46.2914 31.9996 45.8537C31.1473 45.4161 30.3986 44.7999 29.8054 44.0397C29.218 43.2853 28.7976 42.4043 28.5845 41.4713C28.3715 40.5384 28.3657 39.5652 28.5673 38.6265C28.7688 37.6879 29.1719 36.8068 29.7536 36.0409C30.3353 35.275 31.0724 34.6473 31.9247 34.1981L34.165 39.4385C34.4241 40.0374 34.833 40.5615 35.3513 40.9588L39.8721 44.4025C39.2271 45.1166 38.4381 45.681 37.557 46.0553L37.5512 46.0495ZM40.5343 43.533L36.2958 40.3023L41.5306 39.26C41.5594 39.5076 41.5767 39.7553 41.5767 40.0029C41.5767 41.2583 41.2197 42.4791 40.5401 43.533H40.5343Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2692_10611"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#159EB7" />
          <stop offset="1" stop-color="#007E95" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default HistoricalReportsIconHome
